<div class="system-log-item" ng-class="{ 'has-details' : (item.Data.length || item.Exception.length)}">
    <i class="fa fa-bug" ng-if="item.Level == 1" title="{{'system.log.level.debug'|translate}}"></i>
    <i class="fa fa-gear" ng-if="item.Level == 2" title="{{'system.log.level.verbose'|translate}}"></i>
    <i class="fa fa-circle-thin" ng-if="item.Level == 3" title="{{'system.log.level.information'|translate}}"></i>
    <i class="fa fa-warning" ng-if="item.Level == 4" title="{{'system.log.level.warning'|translate}}"></i>
    <i class="fa fa-ban" ng-if="item.Level == 5" title="{{'system.log.level.error'|translate}}"></i>
    <i class="fa fa-minus-circle" ng-if="item.Level == 6" title="{{'system.log.level.critical'|translate}}"></i>
    <span>{{item.Created|cDate:'':'full'}}</span>
    <span>{{item.Message}}</span>
</div>
<div class="system-log-item-details" ng-show="item.visible" ng-if="item.Data.length || item.Exception.length" ng-click="$event.stopPropagation();">
    <section>
        <div style="float: left; margin-right: 20px">
            Section<br/>
            Group
        </div>
        <div>
            <pre style="line-height: 15px">{{item.Section}}</pre>
            <pre style="line-height: 15px">{{item.Group || ' '}}</pre>
        </div>
        <br ng-if="item.Data.length"/>
        <div ng-if="item.Data.length">Data</div>
        <pre ng-if="item.Data.length">{{item.Data}}</pre>
        <br ng-if="item.Exception.length"/>
        <div ng-if="item.Exception.length">Exception</div>
        <pre ng-if="item.Exception.length">{{item.Exception}}</pre>
    </section>
</div>